import { render, staticRenderFns } from "./movemain.vue?vue&type=template&id=118e4872&scoped=true"
import script from "./movemain.vue?vue&type=script&lang=js"
export * from "./movemain.vue?vue&type=script&lang=js"
import style0 from "./movemain.vue?vue&type=style&index=0&id=118e4872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e4872",
  null
  
)

export default component.exports